import { defineComponent as _defineComponent } from 'vue'
import Explore from '@/sections/shared/explore/Explore.vue';
import { useRouter } from '@/plugins/router';


export default /*#__PURE__*/_defineComponent({
  __name: 'ExploreManagerPage',
  setup(__props) {

const router = useRouter();
const teamRequestId = router.currentRoute.query['tr']?.toString();
const loadTrToCart: boolean = !router.currentRoute.query['not-load'] || router.currentRoute.query['not-load'] === 'false';

return { __sfc: true,router, teamRequestId, loadTrToCart, Explore }
}

})